import React, { Component } from 'react';
import {
  Grid,
  Row,
  Button,
  Col,
  Glyphicon,
  Table,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import './Landing.css';
import $ from 'jquery';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from 'react-share';
import ResponsiveEmbed from 'react-responsive-embed';
import { LinkContainer } from 'react-router-bootstrap';
import { HashLink } from 'react-router-hash-link';
import EstimatorFooter from '../components/EstimatorFooter';
import 'animate.css/animate.min.css';
import ScrollAnimation from 'react-animate-on-scroll';

export default class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currency: 'GBP',
      personalMonthGBP: '£13.99',
      personalYearGBP: '£159.99',
      enterpriseMonthGBP: '£91.99',
      enterpriseYearGBP: '£919.99',
      personalMonthUSD: '$14.99',
      personalYearUSD: '$169.99',
      enterpriseMonthUSD: '$99.99',
      enterpriseYearUSD: '$999.99'
    };

    window.scrollTo(0, 0);
    /* $(".App").css("background", "rgb(255, 255, 255, 0)"); */
    $('.App').css('background', 'none');
  }

  renderPersonalMonthPrice() {
    if (this.state.currency === 'GBP') {
      return this.state.personalMonthGBP;
    } else if (this.state.currency === 'USD') {
      return this.state.personalMonthUSD;
    }
  }

  renderPersonalYearPrice() {
    if (this.state.currency === 'GBP') {
      return this.state.personalYearGBP;
    } else if (this.state.currency === 'USD') {
      return this.state.personalYearUSD;
    }
  }

  renderEnterpriseMonthPrice() {
    if (this.state.currency === 'GBP') {
      return this.state.enterpriseMonthGBP;
    } else if (this.state.currency === 'USD') {
      return this.state.enterpriseMonthUSD;
    }
  }

  renderEnterpriseYearPrice() {
    if (this.state.currency === 'GBP') {
      return this.state.enterpriseYearGBP;
    } else if (this.state.currency === 'USD') {
      return this.state.enterpriseYearUSD;
    }
  }

  renderLoginButton() {
    if (this.props.isAuthenticated) {
      return (
        <LinkContainer to="/beta">
          <Button>LOGIN</Button>
        </LinkContainer>
      );
    } else {
      return (
        <LinkContainer to="/login">
          <Button>LOGIN</Button>
        </LinkContainer>
      );
    }
  }

  renderDemoButton() {
    if (this.props.isAuthenticated) {
      return (
        <LinkContainer to="/beta">
          <Button>DEMO</Button>
        </LinkContainer>
      );
    } else {
      return (
        <LinkContainer to="/register">
          <Button>DEMO</Button>
        </LinkContainer>
      );
    }
  }

  renderSignUpButton() {
    if (this.props.isAuthenticated) {
      return (
        <LinkContainer to="/beta">
          <Button>SIGN UP</Button>
        </LinkContainer>
      );
    } else {
      return (
        <LinkContainer to="/register">
          <Button>SIGN UP</Button>
        </LinkContainer>
      );
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  render() {
    const shareURL = 'estimator.digimasters.co.uk';
    return (
      <Grid className="landing-container">
        <Col xs={12} md={12}>
          <Row>
            <Col xs={12} md={9}>
              <h1 className="title-text">Visual Analytics Project Estimator</h1>
            </Col>
            <Col xs={12} md={3}>
              <Row>
                <FacebookShareButton
                  url={shareURL}
                  className="socialmedia-button">
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareURL}
                  className="socialmedia-button">
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareURL}
                  className="socialmedia-button">
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
              </Row>
              <Row>{this.renderLoginButton()}</Row>
            </Col>
          </Row>

          <Row>
            {this.renderDemoButton()}
            <LinkContainer to="/blog">
              <Button>BLOG</Button>
            </LinkContainer>
            <HashLink to="/#pricing">
              <Button>PRICING</Button>
            </HashLink>
          </Row>
          <Row className="solo-text" data-aos="fade-left">
            <Col xs={3} md={3} />
            <Col xs={9} md={9}>
              <ScrollAnimation
                duration={3}
                animateIn="fadeInLeftBig"
                animateOnce={true}>
                <h3>
                  Create an effort estimate for data visualisation dashboards
                  and custom analytics web applications.
                </h3>
              </ScrollAnimation>
            </Col>
          </Row>
          <Row className="solo-text">
            <Col xs={9} md={9}>
              <ScrollAnimation
                duration={3}
                animateIn="fadeInRightBig"
                animateOnce={true}>
                <h3>
                  Improve the accuracy of budgets and timelines with our simple
                  to use estimating engine.
                </h3>
              </ScrollAnimation>
            </Col>
            <Col xs={3} md={3} />
          </Row>
          <Row className="solo-text">
            <Col xs={3} md={3} />
            <Col xs={9} md={9}>
              <ScrollAnimation
                duration={3}
                animateIn="fadeInLeftBig"
                animateOnce={true}>
                <h3>
                  Supports QlikView, Qlik Sense, Tableau, PowerBI, d3.js,
                  Mashups, Looker and many more.
                </h3>
              </ScrollAnimation>
            </Col>
          </Row>
          <Row className="solo-text">
            <Col xs={9} md={9}>
              <ScrollAnimation
                duration={3}
                animateIn="fadeInRightBig"
                animateOnce={true}>
                <h3>
                  Use our preloaded effort calculations based on hundreds of
                  successfully completed projects or refine the effort using
                  your own variable inputs based on your own team's skill level
                  and experience.
                </h3>
              </ScrollAnimation>
            </Col>
            <Col xs={3} md={3} />
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <ResponsiveEmbed
                src="https://www.youtube.com/embed/-mY304rkN3k"
                allowFullScreen
                id="tutorial"
              />
            </Col>
          </Row>
          <Row className="tables-row">
            <Col xs={3} md={3}>
              <Table className="pricing-table" id="pricing">
                <thead>
                  <tr>
                    <th>FEATURES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="dark-blue">
                      Online single project estimate creation
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      Save project estimates and history
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">Export project estimates</td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      Share estimates with other user accounts (in development)
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      Edit the effort variables to refine for your own team's
                      abilities (in development)
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">Support</td>
                  </tr>
                  <tr>
                    <td className="dark-blue">Unlimited Users</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={3} md={3}>
              <Table className="pricing-table">
                <thead>
                  <tr>
                    <th>FREE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={3} md={3}>
              <Table className="pricing-table">
                <thead>
                  <tr>
                    <th>
                      PERSONAL
                      <br />
                      {this.renderPersonalMonthPrice()}
                      /Month
                      <br />
                      {this.renderPersonalYearPrice()}
                      /Year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td className="dark-blue">
                      <Glyphicon glyph="remove" />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={3} md={3}>
              <Table className="pricing-table">
                <thead>
                  <tr>
                    <th>
                      ENTERPRISE
                      <br />
                      {this.renderEnterpriseMonthPrice()}
                      /Month
                      <br />
                      {this.renderEnterpriseYearPrice()}
                      /Year
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Glyphicon glyph="ok" />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col xs={5} md={2}>
              {this.renderSignUpButton()}
            </Col>
            <Col xs={2} md={8} />
            <Col xs={5} md={2}>
              <FormGroup controlId="currency">
                <ControlLabel className="currency-label">Currency</ControlLabel>
                <FormControl
                  componentClass="select"
                  onChange={this.handleChange}
                  value={this.state.currency}>
                  <option value="GBP">GBP</option>
                  <option value="USD">USD</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <HashLink to="/blog/#1">
              <h3>Why use a top down estimator?</h3>
            </HashLink>
            <HashLink to="/blog/#2">
              <h3>Who is the estimator for?</h3>
            </HashLink>
            <HashLink to="/blog/#3">
              <h3>What are a top down estimator's limitations?</h3>
            </HashLink>
            <HashLink to="/blog/#4">
              <h3>What technologies power the estimator?</h3>
            </HashLink>
            {/* <h3>What technology is used to build and host this estimator?</h3> */}
          </Row>
          {/* footer */}
          <EstimatorFooter isAuthenticated={this.props.isAuthenticated} />
        </Col>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Landing.js